export const SET_BUILT_IN_WIFI = 'SET_BUILT_IN_WIFI';

export const setBuiltInWifi = builtInWifi => ({
  type: SET_BUILT_IN_WIFI,
  value: {builtInWifi},
});
